module.exports = __webpack_public_path__ + "img/logo-anagrama.072c4608.svg";